import { AccountData, CreateAccountData } from "@sportal/api";
import { ChangeAPRSettingSuccessAction } from "../attributes/attributes.types";

export const LOAD_ACCOUNT = "[AUTH] LOAD_ACCOUNT";
export const GET_ACCOUNT_SUCCESS = "[AUTH] GET_ACCOUNT_SUCCESS";
export const CREATE_ACCOUNT_FAILURE = "[AUTH] CREATE_ACCOUNT_FAILURE";
export const ACTIVATE_SERVICES_FAILURE = "[AUTH] ACTIVATE_SERVICES_FAILURE";
export const UPDATE_WEB_FILTER_SUCCESS = "[ACCOUNT] UPDATE_WEB_FILTER_SUCCESS";
export const UPDATE_WEB_FILTER_FAILURE = "[ACCOUNT] UPDATE_WEB_FILTER_FAILURE";
export const GET_SPSON = "[ACCOUNT] GET_SPSON";
export const GET_SPSON_SUCCESS = "[ACCOUNT] GET_SPSON_SUCCESS";
export const GET_SPSON_FAILURE = "[ACCOUNT] GET_SPSON_FAILURE";

interface getSpsonSuccessAction {
  type: typeof GET_SPSON_SUCCESS;
}

interface LoadAccountAction {
  type: typeof LOAD_ACCOUNT;
}

interface GetAccountSuccessAction {
  type: typeof GET_ACCOUNT_SUCCESS;
  payload: AccountData | CreateAccountData;
}

interface GetAccountFailureAction {
  type: typeof CREATE_ACCOUNT_FAILURE;
  payload: object & { code: number | string };
}

interface ActivateServicesFailureAction {
  type: typeof ACTIVATE_SERVICES_FAILURE;
  payload: object & { code: number | string };
}

interface UpdateWebFilterSuccessAction {
  type: typeof UPDATE_WEB_FILTER_SUCCESS;
  payload: boolean;
}

interface UpdateWebFilterFailureAction {
  type: typeof UPDATE_WEB_FILTER_FAILURE;
  payload: object & { code: number | string };
}

interface CreateAccountFailure {
  type: typeof CREATE_ACCOUNT_FAILURE;
}

export type AccountActionTypes =
  | LoadAccountAction
  | GetAccountSuccessAction
  | GetAccountFailureAction
  | ActivateServicesFailureAction
  | UpdateWebFilterSuccessAction
  | UpdateWebFilterFailureAction
  | CreateAccountFailure
  | getSpsonSuccessAction
  | ChangeAPRSettingSuccessAction;
